import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import walletApiRequest, { InitPaymentResponse } from "../../../../app/api/customer/walletApiRequest";

interface WalletState {
  walletUri: string;
  walletToken: string;
  mode: number;
  accountBalance: number;
  loading: boolean;
  error: string | null;
}

export const initWalletPayment = createAsyncThunk<
  InitPaymentResponse
>(
  'wallet/initWalletPayment',
  async (data, thunkAPI) => {
    try {
      const response = await walletApiRequest.initiatePayment();
      return response;
    } catch (error: any) {
      if (error.data) {
        return thunkAPI.rejectWithValue(error.data.message);
      }
      return thunkAPI.rejectWithValue('An unknown error occurred');
    }
  }
);

export const getCustomerAccountCredit = createAsyncThunk<
  number
>(
  'wallet/getCustomerAccountCredit',
  async (data, thunkAPI) => {
    try {
      const response = await walletApiRequest.getCustomerAccountCredit();
      return response;
    } catch (error: any) {
      if (error.data) {
        return thunkAPI.rejectWithValue(error.data.message);
      }
      return thunkAPI.rejectWithValue('An unknown error occurred');
    }
  }
);

const walletDataSlice = createSlice({
  name: 'walletData',
  initialState: {
    walletToken: '',
    walletUri: '',
    accountBalance: 0,
    loading: false,
    error: null,
  } as WalletState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initWalletPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.walletToken = '';
        state.walletUri = '';
        state.mode = 0;
      })
      .addCase(initWalletPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.walletUri = action.payload.WalletUri;
        state.walletToken = action.payload.WalletToken;
        state.mode = action.payload.Mode;
      })
      .addCase(initWalletPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.mode = 0;
      })
      .addCase(getCustomerAccountCredit.fulfilled, (state, action) => {
        state.loading = false;
        state.accountBalance = action.payload as number;
      })
      .addCase(getCustomerAccountCredit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default walletDataSlice.reducer;